export function forms($) {

	//---------------------------------------------------------
	// Add span to cutomize checkbox
	//---------------------------------------------------------

	$('.js--form input[type="radio"], .js--form input[type="checkbox"]').after('<span></span>');


	//---------------------------------------------------------
	// Mark 'input', 'select' and 'textarea'  controls
	// when filled or on focus
	//---------------------------------------------------------

	let $inputs = '.js--form input[type="text"], .js--form input[type="file"], .js--form input[type="date"], .js--form input[type="datetime"], .js--form input[type="email"], .js--form input[type="number"], .js--form input[type="password"], .js--form input[type="url"], .js--form input[type="tel"], .js--form select, .js--form textarea';
	let $choices = '.js--form input[type="radio"], .js--form input[type="checkbox"]';

	$($inputs)
		.filter(function () { return $(this).val() !== ""; })
		.closest('.form__field')
		.addClass('form_controlPreFilled');

	$($choices)
		.filter(function () { return $(this).is(':checked'); })
		.closest('.form__field')
		.addClass('form_controlPreFilled')
		.end()
		.filter(function () { return !$(this).is(':checked'); })
		.closest('.form__field')
		.removeClass('form_controlPreFilled');

	$('body').on('change', $inputs, function () {

		$(this).closest('.form__field').removeClass('form_controlPreFilled');

		if ($(this).val() !== "") {
			$(this)
				.closest('.form__field')
				.addClass('form_controlFilled');
		} else {
			$(this)
				.closest('.form__field')
				.removeClass('form_controlFilled');
		}
	}).on('focus', $inputs, function () {
		$(this)
			.closest('.form__field')
			.addClass('form_controlFocus');
	}).on('blur', $inputs, function () {
		$(this)
			.closest('.form__field')
			.removeClass('form_controlFocus');
	}).on('keyup', $inputs, function () {

		$(this).closest('.form__field').removeClass('form_controlPreFilled');

		if ($(this).val() !== "") {
			$(this)
				.closest('.form__field')
				.addClass('form_controlFilled');

		} else {
			$(this)
				.closest('.form__field')
				.removeClass('form_controlFilled');
		}
	});


	$('body').on('change', $choices, function () {

		$(this).closest('.form__field').removeClass('form_controlPreFilled');

		if ($(this).is(':checked')) {
			$(this)
				.closest('.form__field')
				.addClass('form_controlFilled');

		} else {
			$(this)
				.closest('.form__field')
				.removeClass('form_controlFilled');
		}
	});



	// Input files
	function inputFiles() {
		$('.form__field--file input[type="file"]').each(function() {
			var $input = $(this),
					$label = $input.closest('.form__field--file').find('.form__field--file__name'),
					labelVal = $label.html();

				$input.on('change', function(e) {
					var fileName = '';

					if( this.files && this.files.length > 1 ) {
						fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
					} else if( e.target.value ) {
						fileName = e.target.value.split( '\\' ).pop();
					}

					if( fileName ) {
						$label.html( fileName );
					} else {
						$label.html( labelVal );
					}

			});
		});

			// Firefox bug fix
		/*$input
				.on( 'focus', function(){ $input.addClass( 'has-focus' ); })
				.on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
		});*/
	}

	inputFiles();


	// Comments form


		let $inputsComments = '.comment-form input[type="text"], .comment-form input[type="file"], .comment-form input[type="date"], .comment-form input[type="datetime"], .comment-form input[type="email"], .comment-form input[type="number"], .comment-form input[type="password"], .comment-form input[type="url"], .comment-form input[type="tel"], .comment-form select, .comment-form textarea';
		let $choicesComments = '.comment-form input[type="radio"], .comment-form input[type="checkbox"]';

		$($inputsComments)
			.filter(function () { return $(this).val() !== ""; })
			.closest('p')
			.addClass('form_controlPreFilled');

		$($choicesComments)
			.filter(function () { return $(this).is(':checked'); })
			.closest('p')
			.addClass('form_controlPreFilled')
			.end()
			.filter(function () { return !$(this).is(':checked'); })
			.closest('p')
			.removeClass('form_controlPreFilled');

		$('body').on('change', $inputsComments, function () {

			$(this).closest('p').removeClass('form_controlPreFilled');

			if ($(this).val() !== "") {
				$(this)
					.closest('p')
					.addClass('form_controlFilled');
			} else {
				$(this)
					.closest('p')
					.removeClass('form_controlFilled');
			}
		}).on('focus', $inputsComments, function () {
			$(this)
				.closest('p')
				.addClass('form_controlFocus');
		}).on('blur', $inputsComments, function () {
			$(this)
				.closest('p')
				.removeClass('form_controlFocus');
		}).on('keyup', $inputsComments, function () {

			$(this).closest('p').removeClass('form_controlPreFilled');

			if ($(this).val() !== "") {
				$(this)
					.closest('p')
					.addClass('form_controlFilled');

			} else {
				$(this)
					.closest('p')
					.removeClass('form_controlFilled');
			}
		});

    // Search

    $('.search-field').each(function(i, e) {
      let content = $(e).val();
      if (content !== '') {
        $(e).closest('label').addClass('focus');
      }
    });
    $('.search-field').focus(function() {
      $(this).closest('label').addClass('focus');
    }).blur(function() {
      let content = $(this).val();
      if (content === '') {
        $(this).closest('label').removeClass('focus');
      }
    });


}
